import { render } from "./FunctionSettings.vue?vue&type=template&id=37ad8508&scoped=true"
import script from "./FunctionSettings.vue?vue&type=script&lang=js"
export * from "./FunctionSettings.vue?vue&type=script&lang=js"

import "./FunctionSettings.vue?vue&type=style&index=0&id=37ad8508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ad8508"]])

export default __exports__